let html = `<div class="player">
    
</div>`

export default html